import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";

import { useSubheader } from "../../_metronic/layout";
import { baseURL } from "../service/API.js";
import axios from "axios";
import Swal from "sweetalert2";

export const UserPoint = () => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("User Point");
  const [eventType, setEventType] = useState('DEMO_AMOUNT_TO_POINT')
  const [userId, setUserId] = useState('DEMOSALE')
  const [amount, setAmount] = useState(0)

  const addPoint = async () => {
    if (Number(amount) == 0) return Swal.fire(
      "ทำรายการไม่สำเร็จ!",
      "จำนวนเงินไม่ถูกต้อง",
      "error"
    );
    var data = JSON.stringify({
      "user_id": userId,
      "event_type": eventType,
      "total_amount": amount
    });
    var config = {
      method: "post",
      url: baseURL + "/api/v1/ap/point",
      headers: {
        'Content-Type': 'application/json'
      },
      auth: {
        username: "AP001",
        password: "8MPvq6wGE6QeCDTEqQMt3DRj"
      },
      data: data
    };
    await axios(config)
      .then(function (response) {
        Swal.fire(
          "ทำรายการสำเร็จ!",
          "กรุณาตรวจสอบหน้าเว็บ",
          "success"
        );
        return response.data;
      })
      .catch(function (error) {
        Swal.fire(
          "ทำรายการไม่สำเร็จ!",
          "กรุณาลองใหม่อีกครั้ง",
          "error"
        );
        return error.response.data;
      });
  };

  return (
    <Card>
      <CardHeader title="User Point">
      </CardHeader>
      <CardBody>
        <div className="form-inline" style={{ marginBottom: "25px" }}>
          <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
            จำนวนเงิน<span style={{ color: "red" }}>*</span>:{" "}
          </p>
          <div>
            <input
              name="amount"
              type={"number"}
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>
        </div>
        <div
          className="form-inline"
          style={{
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              marginTop: "15px",
              float: "left",
              width: "20%",
            }}
          ></div>

          <button type="button" className="btn btn-secondary wbt mr-5" onClick={() => addPoint()}>
            Add
          </button>
        </div>
      </CardBody>
    </Card>
  );
};
